// Tijdelijke boekingsblokkade per halffabricaat. Leeg sinds 2026-10-08: lotvoorraad gecontroleerd en akkoord.
export const HELD_HALFFABRICATEN = [];

const CONTROLLED_FINAL_BOOKINGS = [
  {
    halffabricaat: "Tower chicken burger 150 gr puur kip filet",
    artikelnummer: "15512",
    kg: 4160,
  },
  {
    halffabricaat: "Chicken sandwich 150 gr",
    artikelnummer: "15538",
    kg: 4160,
  },
];

export const normalizeHalffabName = (value) => String(value || "")
  .trim()
  .toLocaleLowerCase("nl-NL")
  .replace(/\s+/g, " ");

export const isHalffabBookingOnHold = (name) => HELD_HALFFABRICATEN.some((heldName) => (
  normalizeHalffabName(heldName) === normalizeHalffabName(name)
)) && !isControlledFinalBooking(name, "", 0);

export const isControlledFinalBooking = (name, artikelnummer, kg) => CONTROLLED_FINAL_BOOKINGS.some((booking) => (
  normalizeHalffabName(booking.halffabricaat) === normalizeHalffabName(name)
  && String(booking.artikelnummer) === String(artikelnummer || "").trim()
  && Math.abs(Number(kg) - booking.kg) < 0.001
));

export const isHalffabBookingBlocked = (name, artikelnummer, kg) => (
  HELD_HALFFABRICATEN.some((heldName) => (
    normalizeHalffabName(heldName) === normalizeHalffabName(name)
  )) && !isControlledFinalBooking(name, artikelnummer, kg)
);

export const halffabHoldMessage = (name) => (
  `"${name}" is tijdelijk geblokkeerd voor productieboekingen totdat de lotvoorraad is gecontroleerd.`
);